import { heIL as coreHeIL } from "@mui/material/locale";
import {
  createTheme,
  ThemeProvider as ThemeProviderMui,
} from "@mui/material/styles";
import { heIL as calendarHeIL } from "@mui/x-date-pickers/locales";
import { ReactElement, useMemo } from "react";
import { RouterProvider } from "react-router-dom";

import { LocalizationProvider } from "@ryde/controls";
import { GlobalAppContextProvider, useRtl } from "@ryde/redux";
import { Log, shouldDebugForms } from "@ryde/shared";
import { AppGlobalStyles, themeMuiDefault } from "@ryde/theme";
import { i18nInitializedLandingInstance } from "@ryde/utils-landings";

import "../root.css";

import { appLandingRouter } from "./app-landing.router";

export const AppLanding = (): ReactElement => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const i18nImportedLandings =
    i18nInitializedLandingInstance; /* used for initializing i18n */

  const { isRtl, direction } = useRtl();

  const muiTheme = useMemo(() => {
    const curTheme = createTheme(
      {
        ...themeMuiDefault,
        direction,
      },
      isRtl ? calendarHeIL : {},
      isRtl ? coreHeIL : {},
    );
    return curTheme;
  }, [direction, isRtl]);

  if (shouldDebugForms()) {
    Log.warn("react-hook-forms set in debug mode");
  }

  return (
    <ThemeProviderMui theme={muiTheme}>
      <AppGlobalStyles $isRtl={isRtl} />
      <LocalizationProvider>
        <GlobalAppContextProvider>
          <RouterProvider router={appLandingRouter()} />
        </GlobalAppContextProvider>
      </LocalizationProvider>
    </ThemeProviderMui>
  );
};

export default AppLanding;
